import styled from 'styled-components';
import UILink from 'UIComponents/link/UILink';
export const SIGNUP_LINK_COLOR = '#0b8484';
export const StyledUILink = styled(UILink).withConfig({
  displayName: "TextInputstyles__StyledUILink",
  componentId: "sc-1y5z3ug-0"
})(["color:", ";"], SIGNUP_LINK_COLOR);